/* review-link.js — one-time review links (2026-10). See sections/review-link.liquid. */
(function () {
  var box = document.querySelector('[data-review-link]');
  if (!box) return;
  var token = new URLSearchParams(location.search).get('t') || '';
  if (!token) return;

  var base = box.getAttribute('data-base') || '';
  var endpoint = base + '/reviews/link?t=' + encodeURIComponent(token);
  function $(sel) { return box.querySelector(sel); }
  function show(el, on) { if (el) el.hidden = !on; }

  var loading = $('[data-rl-loading]');
  var state = $('[data-rl-state]');
  var form = $('[data-rl-form]');
  var done = $('[data-rl-done]');
  var error = $('[data-rl-error]');
  var nameInput = $('[data-rl-name]');
  var comment = $('[data-rl-comment]');
  var submit = $('[data-rl-submit]');
  var google = null;

  show(box, true);
  box.scrollIntoView({ block: 'start' });

  function stateMsg(key) {
    show(loading, false);
    show(form, false);
    state.textContent = state.getAttribute(key) || state.getAttribute('data-generic') || '';
    show(state, true);
  }

  function fill(sel, value, token) {
    var el = $(sel);
    if (!el || !value) return;
    el.textContent = (el.getAttribute('data-text') || '').replace(token, value);
    show(el, true);
  }

  var stars = box.querySelectorAll('[data-rv-star]');
  var rating = 0;
  function paint(n) {
    for (var i = 0; i < stars.length; i++) {
      var v = Number(stars[i].getAttribute('data-rv-star'));
      stars[i].classList.toggle('is-on', v <= n);
      stars[i].setAttribute('aria-checked', v === rating ? 'true' : 'false');
    }
  }
  for (var i = 0; i < stars.length; i++) {
    (function (star) {
      var v = Number(star.getAttribute('data-rv-star'));
      star.addEventListener('click', function () { rating = v; paint(rating); hideError(); });
      star.addEventListener('mouseenter', function () { paint(v); });
    })(stars[i]);
  }
  var group = $('[data-rv-stars]');
  if (group) group.addEventListener('mouseleave', function () { paint(rating); });

  function showError(key) {
    error.textContent = error.getAttribute(key) || error.getAttribute('data-generic') || '';
    show(error, true);
  }
  function hideError() { show(error, false); }
  comment.addEventListener('input', hideError);

  function readJson(res) {
    return res.json().then(function (b) { return { status: res.status, body: b || {} }; },
      function () { return { status: res.status, body: {} }; });
  }

  fetch(endpoint, { headers: { Accept: 'application/json' } })
    .then(readJson)
    .then(function (out) {
      var d = out.body;
      if (out.status === 404) return stateMsg('data-missing');
      if (out.status !== 200) return stateMsg('data-generic');
      google = d.google || null;
      fill('[data-rl-hello]', (d.name || '').split(' ')[0], '[[n]]');
      fill('[data-rl-for]', d.label, '[[l]]');
      if (d.cover) {
        var img = $('[data-rl-cover]');
        img.src = d.cover;
        show(img, true);
      }
      if (d.state === 'used') return stateMsg('data-used');
      if (d.state === 'expired') return stateMsg('data-expired');
      nameInput.value = d.name || '';
      show(loading, false);
      show(form, true);
    })
    .catch(function () { stateMsg('data-generic'); });

  submit.addEventListener('click', function () {
    var text = comment.value.trim();
    if (!rating) { showError('data-need-rating'); return; }
    if (text.length < 3) { showError('data-need-comment'); comment.focus(); return; }
    hideError();
    submit.disabled = true;
    submit.textContent = submit.getAttribute('data-busy') || '';
    fetch(endpoint, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: nameInput.value.trim(), rating: rating, comment: text })
    })
      .then(readJson)
      .then(function (out) {
        if (out.status === 200 && out.body.ok) {
          show(form, false);
          var g = out.body.google || google;
          if (g) {
            $('[data-rl-google-link]').href = g;
            show($('[data-rl-google]'), true);
          }
          show(done, true);
          return;
        }
        if (out.status === 410) return stateMsg('data-used');
        submit.disabled = false;
        submit.textContent = submit.getAttribute('data-label') || '';
        showError('data-generic');
      })
      .catch(function () {
        submit.disabled = false;
        submit.textContent = submit.getAttribute('data-label') || '';
        showError('data-generic');
      });
  });
})();
